/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CancelCheckoutRequest
 */
export interface CancelCheckoutRequest {
    /**
     * 注文の商品をカートに戻すかどうか
     * @type {boolean}
     * @memberof CancelCheckoutRequest
     */
    restoreToCart?: boolean;
}

/**
 * Check if a given object implements the CancelCheckoutRequest interface.
 */
export function instanceOfCancelCheckoutRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CancelCheckoutRequestFromJSON(json: any): CancelCheckoutRequest {
    return CancelCheckoutRequestFromJSONTyped(json, false);
}

export function CancelCheckoutRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelCheckoutRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'restoreToCart': !exists(json, 'restore_to_cart') ? undefined : json['restore_to_cart'],
    };
}

export function CancelCheckoutRequestToJSON(value?: CancelCheckoutRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'restore_to_cart': value.restoreToCart,
    };
}

